import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'reactstrap';
import TopModuleTile from './TopModuleTile';
import TopModuleMobileTile from './TopModuleMobileTile';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";




function EirTopModule(props) {

    const renderContent = (content) => {
        return { __html: content };
    }

    if (props.parentContent && props.FolderName) {
        let parentRef = props.parentContent;
        let getParentFolder = props.FolderName;
        var parentContentArray = [];
        let getCount = (getParentFolder != undefined) ? getParentFolder.split("/") : '';
        Object.values(parentRef).forEach(value => {
            parentContentArray.push({ "filepath": value.fileName, "displayname": value.displayName, "displayicon": value.displayIcon, "isParent": Boolean(value.isParent), "hideMenu": value.hideMenu });
        });
        var firstChildArray = [];
        var desktopTiles = props.DesktopTiles;
        for (var i = 0; i < parentContentArray.length; i++) {
            if ((getCount.length + 1 == parentContentArray[i].filepath.split("/").length) && (!parentContentArray[i].hideMenu)) {
                firstChildArray.push(parentContentArray[i]);
            }
        }
        var mobiletile = [];
        for (var dTile = 0; dTile < desktopTiles.length; dTile++) {
            for (var MTile = 0; MTile < firstChildArray.length; MTile++) {
                if (desktopTiles[dTile].link === firstChildArray[MTile].filepath) {
                    mobiletile.push(firstChildArray[MTile])
                }
            }
        }
    }


    useEffect(() => {
        //Logic to display same height for all the tiles in a row irrespective of content
        if (!isMobileOnly) {
            let getParentReference = document.getElementById("top-module-tiles-ctr-" + props.occurence);
            var tiles = getParentReference.querySelectorAll(".three-six-desktop .top-module-tile");

            var RowTiles = [];
            for (var k = 0; k < tiles.length; k += 3) {
                for (var i = k; i < k + 3; i++) {
                    (tiles[i]) ? RowTiles.push(parseInt(tiles[i].clientHeight)) : '';
                }
                for (var j = k; j < k + 3; j++) {
                    (tiles[j]) ? tiles[j].style.height = Math.max.apply(Math, RowTiles) + "px" : '';
                }
                RowTiles = [];
            }
        }

    })

    //To get background based on device
    const getBackgroundImage = () => {
        if (isMobile && !isTablet) {
            return (props.MobileBackgroundImage) ? props.MobileBackgroundImage.path : '';
        }
        return (props.DesktopBackgroundImage) ? props.DesktopBackgroundImage.path : '';
    }
    const getBackgroundColor = () => {
        if (isMobile && !isTablet) {
            return (props.MobileBackgroundColor) ? props.MobileBackgroundColor : '';
        }
        return (props.DesktopBackgroundColor) ? props.DesktopBackgroundColor : '';
    }

    return (
        <div id={"top-module-tiles-ctr-" + props.occurence} className="top-module-main">
            {(!isMobile || isTablet) &&
                <div className='pt-4 pb-4 tm-bg' style={{
                    backgroundImage: "url(" + getBackgroundImage() + ")",
                    backgroundColor: getBackgroundColor(),
                }} >

                    <div className="homepage-modules-title" dangerouslySetInnerHTML={renderContent(props.DesktopTitle)}></div>
                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row className="justify-content-center">
                            {props.DesktopTiles.map((tile, i) => {
                                return (
                                    <Col className={'three-six-desktop mt-mb-30 col-4'} >
                                        <Card className="three_six_card">
                                            <TopModuleTile id={'top module tile ' + (i + 1)}
                                                tile={tile} module={props}>
                                            </TopModuleTile>
                                        </Card>
                                    </Col>
                                );
                            })
                            }
                        </Row>
                    </Container>
                </div>
            }
            {(isMobileOnly) &&
                <div className='pt-4 pb-4 tm-bg' style={{
                    backgroundImage: "url(" + getBackgroundImage() + ")",
                    backgroundColor: getBackgroundColor(),
                }} >

                    <div className="homepage-modules-title" dangerouslySetInnerHTML={renderContent(props.MobileTitle)}></div>
                    <Container className={isMobileOnly ? 'mobilelandscapeContainer' : ''}>
                        <Row className="justify-content-center">

                            {mobiletile.map((tile, i) => {
                                return (
                                    <Col id={'top module tile ' + (i + 1)} className={'three-six-desktop col-12'} >
                                        <TopModuleMobileTile index={i + 1} tileLength={mobiletile.length}
                                            tile={tile} module={props} parentContentArray={parentContentArray}>
                                        </TopModuleMobileTile>
                                    </Col>
                                );
                            })
                            }
                        </Row>
                    </Container>
                </div>

            }
        </div>
    );
}
export default EirTopModule;

